<div class="loader">
  <div class="loadingio-spinner-bean-eater-jpi9yekt1hb">
    <div class="ldio-k22r9c47i9t">
      <div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
<div id="toup" class="toup"><i class="fas fa-angle-up"></i></div>
<header class="toolbar">
  <div class="logo">
    <a href="." target="_self">{{ title }}</a>
  </div>
  <nav class="d-sm-none d-none d-xs-none d-md-none d-lg-block">
    <ul id="nlink" class="nav_links">
      <div class="marker"></div>
      <li *ngFor="let navLink of navLinks"><a (click)="scrollIntoView(navLink.id)" [class]="navLink.id" [id]="navLink.eid">{{navLink.title}}</a></li>
    </ul>
  </nav>
  <div class="d-none d-lg-block">
    <a (click)="scrollIntoView('cu')" id="contactus" class="contact">Contact us</a>
  </div>
  <div class="d-lg-none d-block d-xl-none">
    <div class="menu-btn">
      <!-- d-lg-none d-block d-xl-none -->
      <span class="burger"></span>
    </div>
  </div>
</header>
<div class="expand">
  <nav class="d-block d-lg-none">
    <ul>
      <li *ngFor="let navLink of navLinks"><a (click)="scrollIntoView(navLink.id)" [class]="navLink.id" [id]="navLink.eid">{{navLink.title}}</a></li>
      <li><a (click)="scrollIntoView('cu')" class="cu">Contact</a></li>
    </ul>
    <div class="social">
      <a target="_blank" *ngFor="let social of socials" [attr.href]="social.link"
      ><i [class]="social.className"></i
      ></a>
    </div>
  </nav>
</div>
<section class="main" id="h">
  <div class="scrolldown">
    <span>Scroll Down </span><i class="fal fa-angles-right"></i>
  </div>
  <div class="intro" id="intro">
    <h3>Hey, I'm<span>Kunal Jain</span></h3>
    <h4>A <span id="animate"></span></h4>
  </div>
  <div class="image d-none d-lg-block d-xl-block" id="image">
    <img src="../assets/4.png" class="img-responsive" alt="hey" />
  </div>
</section>
<section class="about" id="au">
  <h1 class="shead wim">who i am</h1>
  <h2 class="titles">About me</h2>

  <div class="box container">
    <p class="text-justify">
      A dedicated, hardworking, and energetic Frontend Developer with the main
      skill set of frontend technologies like React, Angular, etc. and before
      being a developer I'm a programmer seeking to leverage acquired academic &
      professional knowledge into practical use.<br /><br />I've worked with a
      startup for a year and have experience in front-end technologies like
      React, Angular, JavaScript, HTML5, CSS3, and Sass. Nowadays, seeking a
      full-time opportunity for an SDE-1 or Frontend developer role.
    </p>
    <div class="panel row">
      <div class="col-md-6 center col-12">
        <button (click)="scrollIntoView('cu')">
          <i class="fal fa-paper-plane-top"></i> Hire me
        </button>
      </div>
      <div class="col-md-6 center col-12">
        <button (click)="downloadResume()">
          <i class="fal fa-file-arrow-down"></i> Download Resume
        </button>
      </div>
    </div>
  </div>
</section>
<section class="services" id="se">
  <h1 class="shead wic">what i can</h1>
  <h2 class="titles">My Services</h2>
  <div class="boxes">
    <div class="container">
      <div class="row">
        <div *ngFor="let service of services; let i = index" class="inner col-lg-6 col-12">
          <div [class]="'box s'+(i+1)">
            <div class="photo" [attr.data-text]="service.title">
              <i [class]="service.iconClass"></i>
            </div>
            <div class="content">
              <h1 class="text-right mb-0">{{service.title}}</h1>
              <p class="text-right soon">{{service.details}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="skills" id="s">
  <h1 class="shead wik">what i have</h1>
  <div class="both container-fluid">
    <div class="row">
      <div class="smain col-lg-6 col-12">
        <h2 class="titles">My skills</h2>
        <p class="text-left">{{ skillsContent }}</p>
      </div>
      <div class="visual col-lg-6 col-12">
        <ng-container *ngFor="let skill of skills">
          <div class="skill">
            <div class="s_title">
              <div class="name">
                <i
                  [class]="skill.className"
                  [style.color]="skill.logoColour"
                ></i
                >{{ skill.name }}
              </div>
              <div class="percent">{{ s[skill.pName] }}%</div>
            </div>
            <div class="bar">
              <div [class]="'fillings ' + skill.pName"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<section class="projects" id="p">
  <h1 class="shead wid">what i done</h1>
  <div class="box">
    <h2 class="titles">My projects</h2>
    <div class="project-box">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let p of projects">
          <ng-template carouselSlide>
            <div class="project-main pro1">
              <div [attr.id]="'pro' + p.id" class="project">
                <img [attr.src]="p.bg" height="350px" width="300px" />
              </div>
              <div class="caption">
                <h2>{{ p.name }}</h2>
                <p>{{ p.details }}</p>
                <div class="tech">
                  <div
                    class="badge badge-dark badge-pill mr-2 mb-1"
                    *ngFor="let t of p.tech"
                  >
                    {{ t }}
                  </div>
                </div>
                <a href="{{ p.link }}" target="_blank" class="float-right"
                  >Check it out</a
                >
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
<section class="teams" id="t">
  <h1 class="shead wwm">Who's with me</h1>
  <h2 class="titles">My team</h2>
  <div class="carousel container">
    <div class="row">
      <div class="col-lg-4 col-md-12 col-12 center">
        <div class="card c1">
          <div class="box">
            <div class="image">
              <img
                src="../assets/team/kratik.jpg"
                style="transform: scale(1.5)"
                alt=""
              />
            </div>
            <div class="text">Kratik Wadekar</div>
            <p>
              B.Tech CSE<br />
              Full Stack Developer
            </p>
            <div class="sicons">
              <a target="_blank" href="https://www.facebook.com/kratik.wadekar"
                ><i class="fab fa-facebook"></i
              ></a>
              <a target="_blank" href="https://twitter.com/KratikW"
                ><i class="fab fa-twitter"></i
              ></a>
              <a
                target="_blank"
                href="https://www.instagram.com/kratik_wadekar/"
                ><i class="fab fa-instagram"></i
              ></a>
              <a target="_blank" href="https://www.github.com/Kratik007"
                ><i class="fab fa-github"></i
              ></a>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/kratik-wadekar-9818551a0/"
                ><i class="fab fa-linkedin"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-12 center">
        <div class="card c2">
          <div class="box">
            <div class="image">
              <img
                src="../assets/team/mayank.jpg"
                style="transform: translate(-15px, 10px) scale(2)"
                alt=""
              />
            </div>
            <div class="text">Mayank Sharma</div>
            <p>
              B.Tech CSE<br />
              Full Stack Developer
            </p>
            <div class="sicons">
              <a
                target="_blank"
                href="https://www.facebook.com/profile.php?id=100063397485461"
                ><i class="fab fa-facebook"></i
              ></a>
              <a target="_blank" href="https://www.instagram.com/mynk._.sharma/"
                ><i class="fab fa-instagram"></i
              ></a>
              <a target="_blank" href="https://www.github.com/mynk26"
                ><i class="fab fa-github"></i
              ></a>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/mayank-sharma-a634b71ab/"
                ><i class="fab fa-linkedin"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-12 center">
        <div class="card c3">
          <div class="box">
            <div class="image">
              <i style="font-size: 7.5em" class="fad fa-user-tie"></i>
            </div>
            <div class="text">Need MERN/MEAN stack developer</div>
            <p>If interested then,</p>
            <input
              type="button"
              style="cursor: pointer"
              (click)="scrollIntoView('cu')"
              class="apply"
              value="Drop me a message"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="contactus" id="cu">
  <h1 class="shead gito">Get in touch</h1>
  <div class="both container-fluid">
    <div class="row">
      <div class="col-lg-6 col-12">
        <div class="cus l h-100">
          <h2 class="titles">Contact me</h2>
          <div class="cont">
            <a><i class="fas fa-location-arrow"></i>Gurugram, INDIA</a>
            <a><i class="fas fa-mobile"></i>+91 8770555943</a>
            <a href="mailto:kunaljain649@gmail.com"
              ><i class="fas fa-envelope"></i>kunaljain649@gmail.com</a
            >
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="cus r h-100">
          <h2 class="titles">Send message</h2>
          <form #query="ngForm" (ngSubmit)="send(query.form)">
            <div class="form-group">
              <div class="group">
                <label for="fname">Full Name</label>
                <div>
                  <input
                    type="text"
                    name="fname"
                    id="fname"
                    #name="ngModel"
                    pattern="[a-zA-Z' ']{1,20}"
                    [class.notvalid]="name.invalid && name.touched"
                    required
                    autocomplete="off"
                    class="form-control"
                    [(ngModel)]="c.name"
                  />
                  <div *ngIf="name.errors && (name.valid || name.touched)">
                    <small class="text-danger" *ngIf="name.errors.required"
                      >Name is required</small
                    >
                    <small class="text-danger" *ngIf="name.errors.pattern"
                      >Should only contain alphabets (A-Z,a-z)</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label for="mail">Email ID</label>
                <div>
                  <input
                    type="email"
                    id="mail"
                    name="mail"
                    #mail="ngModel"
                    [class.notvalid]="mail.invalid && mail.touched"
                    pattern="[A-Za-z\d\._-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,5})(\.[a-zA-Z]{2,5})?"
                    required
                    autocomplete="off"
                    class="form-control"
                    [(ngModel)]="c.email"
                  />
                  <div *ngIf="mail.errors && (mail.valid || mail.touched)">
                    <small class="text-danger" *ngIf="mail.errors.required"
                      >Email ID is required</small
                    >
                    <small class="text-danger" *ngIf="mail.errors.pattern"
                      >Invalid email address</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label for="mob">Mobile Number</label>
                <div>
                  <input
                    type="text"
                    id="mob"
                    name="mob"
                    #mob="ngModel"
                    [class.notvalid]="mob.invalid && mob.touched"
                    pattern="[0-9]{1,10}"
                    minlength="10"
                    maxlength="10"
                    autocomplete="off"
                    class="form-control"
                    [(ngModel)]="c.mobile"
                  />
                  <div *ngIf="mob.errors && (mob.valid || mob.touched)">
                    <small
                      class="text-danger"
                      *ngIf="mob.errors.minlength || mob.errors.pattern"
                      >Invalid mobile number</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label for="msg">Message</label>
                <div>
                  <textarea
                    required
                    id="msg"
                    #msg="ngModel"
                    ngModel
                    [class.notvalid]="msg.invalid && msg.touched"
                    name="msg"
                    class="form-control"
                    [(ngModel)]="c.message"
                  ></textarea>
                  <div *ngIf="msg.invalid && msg.touched">
                    <small
                      class="text-danger"
                      [class.d-none]="msg.valid || msg.untouched"
                      >Message content is required</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <button
                type="submit"
                class="form-control sub"
                (click)="untouch(query.form)"
              >
                <i class="fas fa-paper-plane" *ngIf="!spin"></i>
                <i class="fas fa-circle-notch" *ngIf="spin"></i
                ><span>SEND</span>
              </button>
            </div>
          </form>
          <div *ngIf="showError" class="crc text-danger">
            Some error occured, Please try again later
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<footer>
  <div class="intro">
    <h1>kunal jain</h1>
  </div>
  <div class="social">
    <a target="_blank" *ngFor="let social of socials" [attr.href]="social.link"
      ><i [class]="social.className"></i
    ></a>
  </div>
  <div class="copy">
    <h4>
      Copyright <i class="far fa-copyright"></i>{{ currentYear }}
      <p>{{ title }}</p>
      | All rights reserved<br>Designed with
      <i class="fas fa-heart text-danger"></i> by Kunal
    </h4>
  </div>
</footer>
